import { orderBy } from 'lodash-es'
import React from 'react'

import { FvNum } from '@fv/client-components'
import type { QuoteHistory } from '@fv/models'
import type { DTO } from '@fv/models/core'

import { AdminDate } from '@/components/shared/AdminDate'
import { AdminTable } from '@/components/shared/AdminTable'
import { AdminTooltip } from '@/components/shared/AdminTooltip'

interface QuoteHistoryTableProps {
  history: DTO<QuoteHistory[]>
}

export const QuoteHistoryTable = ({ history }: QuoteHistoryTableProps) => {
  return (
    <AdminTable
      data={orderBy(history, ['date'], ['desc'])}
      rowKey={(h: DTO<QuoteHistory>) => `${h.date}-${h.amount}`}
      columns={[
        {
          key: 'date',
          label: 'Date',
          render: (h: DTO<QuoteHistory>) => (
            <AdminDate val={h.date} format="MM/DD/YYYY hh:mm:ssa" />
          ),
        },
        {
          key: 'amount',
          label: 'Amount',
          render: (h: DTO<QuoteHistory>) => <FvNum val={h.amount} />,
        },
        {
          key: 'method',
          label: 'Method',
          render: (h: DTO<QuoteHistory>) => h.method || 'N/A',
        },
        {
          key: 'charges',
          label: 'Charges',
          render: (h: DTO<QuoteHistory>) => {
            const charges = h.charges || []
            const chargeCount = charges.length

            if (chargeCount === 0) {
              return 'None'
            }

            return (
              <AdminTooltip
                label={
                  <dl className="grid grid-cols-2">
                    {charges.map((charge: any, index: number) => (
                      <React.Fragment key={index}>
                        <dt>{charge.name}</dt>
                        <dd className="text-right">${charge.amount}</dd>
                      </React.Fragment>
                    ))}
                  </dl>
                }
              >
                <span className="link">
                  {chargeCount} charge{chargeCount !== 1 ? 's' : ''}
                </span>
              </AdminTooltip>
            )
          },
        },
      ]}
    />
  )
}
